import check from '../../assets/aboutuspage/icons/check.png'

const data = [
    {
        id : 1,
        img: check,
        bgcolor:'#BFFFFC',
        title: 'Technology-powered meritocracy',
        para:'We believe that investing in smart technology can push us closer to a meritocratic future, in which important decisions will be made based on proven facts, risks and danger will be identified instantly, and human productivity will soar while the costs of running a business - measured in time, money and negative environmental impact - plummet.'
    },
    {
        id : 2,
        img: check,
        bgcolor: '#BFFFFC',
        title: 'Predictability in business',
        para:'We make business processes more predictable with improved productivity and higher profits. We solve staffing challenges through easily scalable automated workflows. We take care of security and data safety by processing data without any humans accessing it.'
    },
    {
        id : 3,
        img: check,
        title: 'Introducing digital transformation',
        para:'We help companies of all sizes usher in digital transformation by leveraging smart technology. Robotic process automation, coupled with machine learning and artificial intelligence, can learn and find new solutions to problems as they arise, leading to more effective business processes.'
    },
]

export default data;